import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../components/Header';

const ErrorPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { message } = location.state || { message: 'Something went wrong' };

    return (
        <div className="error-page">
            <Header />
            <div className="error-content">
                <h2>Error</h2>
                <p>{message}</p>
                <button onClick={() => navigate('/')} className="back-button">Back to Home</button>
            </div>
        </div>
    );
};

export default ErrorPage;
